<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      ref="filterRef"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

export default {
  name: 'OnlinePreRegistrationMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
        },
        filters: {
          academicYear: null,
          center: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Preregistro en línea',
        icon: 'fas fa-file-invoice pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Preregistro en línea'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          placeholder: 'Año académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-6',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'CSEE',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          class: 'col-12 col-md-6',
          validations: null,
          disabled: this.model.search.collections.centers.length === 1,
        },
      ];
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async onChangeAcademicYear() {
      await this.getCenters();
    },
    async setFilters() {
      const {
        data: years,
      } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = [...years];
      this.model.search.filters.academicYear = years[0];
      await this.getCenters();
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      }).then((res) => {
        if(res.data.length === 1) {
          this.model.search.filters.center = res.data[0];
        }
        this.model.search.collections.centers = res.data;
      });
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        await this.process();
      }
    },
    async process() {
      try {
        const centerId = (this.model.search.filters.center || {}).id || '';
        const academicYearId = (this.model.search.filters.academicYear || { }).id || '';
        const { data } = await ReportServices.getReport(
          `studentPreregister/${academicYearId}/${centerId}`,
          {}
        );

        if (data) {
          DocumentServices.Download(data);
        } else {
          this.ShowToast(
            'Error',
            'No existen registros con estos criterios.',
            'error'
          );
        }
      } catch {
        this.ShowToast('Error', 'Error al intentar cargar el reporte', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-process {
  bottom: -1px !important;
  right: 15px !important;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
</style>
